// extracted by mini-css-extract-plugin
module.exports = {"NoteHolder":"AddNote_NoteHolder__1qac0","NoteTextAreaHolder":"AddNote_NoteTextAreaHolder__aXeRn"};